import { createFileRoute } from '@tanstack/react-router';
import { JourneysImportsHandoff } from '@/pages/workspaces/imports/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/imports` URL. Flag off it renders the embedded host; flag on it forwards
 * to the migrated URL.
 *
 * `appBundle` belongs here and not on the migrated twin: this URL keeps the `journeys` segment,
 * so the resolver's bundle-aware branch can rebuild the target from the bundle prefix when the
 * `/workspaces/last` sentinel needs resolving.
 */
function JourneysImportsIndexRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysImportsHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/imports/')({
  component: JourneysImportsIndexRoute,
});
